/**
 * [web] Code repository navigation and URL state.
 * Owns: valid sidebar destinations and their existing /gitlab query parameters.
 * Boundary: presentation routing only; GitLab permissions remain enforced by the server.
 */
export type GitlabTab =
  | 'projects'
  | 'commits'
  | 'analytics'
  | 'users'
  | 'connection'
  | 'identities';

export function readGitlabTab(raw: string | null, canAudit: boolean, isAdmin = false): GitlabTab {
  if (raw === 'commits') return 'commits';
  if (raw === 'analytics' && canAudit && isAdmin) return 'analytics';
  if (raw === 'users' && canAudit && isAdmin) return 'users';
  if (raw === 'identities' && canAudit && isAdmin) return 'identities';
  if (raw === 'connection' && !canAudit) return 'connection';
  return 'projects';
}

/** Preserve the chosen credential and project across sections, but start each list on page one. */
export function gitlabTabHref(tab: GitlabTab, current: URLSearchParams): string {
  const next = new URLSearchParams(current);
  next.delete('page');
  if (tab === 'projects') next.delete('tab');
  else next.set('tab', tab);
  const search = next.toString();
  return `/gitlab${search ? `?${search}` : ''}`;
}
